import AddToCartActions, { addToCartActionTypes } from '../../actions/addToCart/addToCartActions';

const AddToCartReducers = (state = {}, action) => {
  switch (action.type) {
  case addToCartActionTypes.NEW_ADD_TO_CART.LOADING: {
    const { addToCartLoadingV2 } = action;
    return {
      ...state,
      addToCartLoadingV2,
    };
  }
  case addToCartActionTypes.NEW_GET_CART.LOADING: {
    const { getCartV2Loading } = action;
    return {
      ...state,
      getCartV2Loading,
    };
  }
  case addToCartActionTypes.NEW_GET_CART.SUCCESS: {
    const { cartDataV2 } = action;
    return {
      ...state,
      cartDataV2,
    };
  }
  default: {
    return state;
  }
  }
};

export default AddToCartReducers;
